import {ICON} from "../../Icons/Icons";

const audioElement = document.querySelector('#audio-notification');

export class IncomingCallDialog {
  constructor() {
    this.isVisible = false;
  }

  getTemplate() {
    return `
<div class="calling-popup calling-popup--incoming-call video_notification_from_${this.senderInfo.userId}">
  <input type='hidden' class='call_with_audio' value='${this.data.withSound}' />
  <input type='hidden' class='call_with_video' value='${this.data.withCamera}' />
  <input type='hidden' class='call_scope_id' value='${this.data.scopeId}' />
  <input type='hidden' class='call_scope_name' value='${this.data.scopeDisplayName}' />
  <input type='hidden' class='call_unique_class' value='video_notification_from_${this.senderInfo.userId}' />
  
  <div class="calling-popup__icon-wrapper">
    <div class="calling-popup__icon-pulse calling-popup__icon-pulse--outer"></div>
    <div class="calling-popup__icon-pulse calling-popup__icon-pulse--middle"></div>
    <div class="calling-popup__icon-pulse calling-popup__icon-pulse--inner"></div>
    <div class="calling-popup__icon">
      ${ICON.CALL}
    </div>
  </div>
  <div class="calling-popup__text">
    <span class="calling-popup__name">${this.senderInfo.userName}</span>
    <span class="calling-popup__status">${$trans('is-calling-you-text')}</span>
  </div>
  <div class="calling-popup__actions">
    <button class="calling-popup__button calling-popup__button--accept respond_video_call">
      <span>Start Video Call</span>
    </button>
    <button class="calling-popup__button calling-popup__button--decline reject_video_call">
      <span>Decline</span>
    </button>
  </div>
</div>
`
  }

  setupListeners() {
    this.template.find('.calling-popup__button--cancel').on('click', () => {
      this.hide();
      // Trigger event for call cancellation
      $(document).trigger('calling:cancelled');
    });
  }

  init({data, senderInfo, model}) {
    this.data = data;
    this.senderInfo = senderInfo;
    this.model = model

    $(`.video_notification_from_${this.senderInfo.userId}`).remove();

    this.template = $(this.getTemplate());

    this.template.data('controller', this);

    this.setupListeners()
  }

  show() {
    // Append to body if not already in DOM
    if (!this.template.parent().length) {
      $('body').append(this.template);
    }

    // const activeCalls = $("#video_notifications > .call_notification").length;
    // $('#notification_toggle_button').attr('data-count', activeCalls);
    // $('#notification_toggle_button').show();
    // $('#notification_toggle_button').addClass('ringing');
    if (audioElement) {
      if (audioElement.src !== `media/call_ringtone.mp3`) {
        audioElement.src = `media/call_ringtone.mp3`;
      }
      audioElement.play();
    }

    // Show the popup with animation
    this.template.addClass('calling-popup--visible');
    this.isVisible = true;

    console.log('IncomingCallNotification');
  }

  initAndShow({data, senderInfo, model}) {
    this.init({data, senderInfo, model});

    this.show();
  }

  hide() {
    this.template.removeClass('calling-popup--visible');
    this.isVisible = false;

    // Remove from DOM after animation completes
    setTimeout(() => {
      if (!this.isVisible) {
        this.template.detach();
      }
    }, 300);
  }
}
